<template>
  <base-form :title="formTitle"
             :loading="loading"
             @submit="onSubmit">
    <div class="d-flex">
      <div class="px-4">
        <fg-input :label="$t('generic.image')">
          <image-upload id="form-image"
                        size-type="upload"
                        @on-change="onImageChange"
                        :name="model.name"
                        :src="model.logo">
          </image-upload>
        </fg-input>

        <fg-input :label="$t('organization.details.edit.header')">
          <image-upload id="header-image"
                        size-type="upload"
                        @on-change="onHeaderChange"
                        :name="model.header"
                        :src="model.header">
          </image-upload>

          <small slot="infoBlock">
            {{$t('organization.details.edit.headerHelp')}}
          </small>
        </fg-input>

      </div>
      <div class="col-12 col-sm-8 col-xl-10">
        <fg-input :placeholder="$t('organization.details.edit.name')"
                  :name="$t('organization.details.edit.name')"
                  required
                  :error="getError($t('organization.details.edit.name'))"
                  :label="$t('organization.details.edit.name')"
                  v-validate="modelValidations.name"
                  v-model="model.name">
        </fg-input>

        <fg-input :placeholder="$t('organization.details.edit.slogan')"
                  :name="$t('organization.details.edit.slogan')"
                  :error="getError($t('organization.details.edit.slogan'))"
                  :label="$t('organization.details.edit.slogan')"
                  v-validate="modelValidations.slogan"
                  v-model="model.slogan">
        </fg-input>

        <fg-input :error="getError($t('organization.details.edit.text_about'))"
                  :label="$t('organization.details.edit.text_about')">
          <wysiwyg :name="$t('organization.details.edit.text_about')"
                   class="form-control"
                   key="organization_text"
                   :class="{'has-danger': getError($t('organization.details.edit.text_about'))}"
                   v-model="model.text_about">
          </wysiwyg>
        </fg-input>

        <div class="row" v-for="segmentGroup in organisationSegmentGroups">
          <div class="col-12">
            <fg-input :label="segmentGroup.name"
                      :error="getError(segmentGroup.name)">
              <el-select multiple
                         :multiple-limit="segmentGroup.validation_max"
                         class="select-default"
                         :name="segmentGroup.name"
                         :placeholder="segmentGroup.name"
                         filterable
                         clearable
                         v-model="selectedSegments[segmentGroup.slug]">
                <el-option class="select-default"
                           v-for="option in allSegments[segmentGroup.slug]"
                           :value="option.id"
                           :label="option.value"
                           :key="option.id">
                </el-option>
              </el-select>
            </fg-input>
          </div>
        </div>

        <fg-input :placeholder="$t('organization.details.edit.locationHq')"
                  :label="$t('organization.details.edit.locationHq')"
                  id="company_location"
                  component="vue-google-autocomplete"
                  types="(cities)"
                  autocomplete="new-password"
                  :name="$t('organization.details.edit.locationHq')"
                  v-model="model.location_hq"
                  @change="onLocationChange"
                  addon-left-icon="nc-icon nc-pin-3">
        </fg-input>

        <fg-input :label="$t('organization.details.edit.active')">
          <base-switch v-model="model.active"/>
        </fg-input>
      </div>
    </div>
    <template v-if="model.id" v-slot:content>
      <section-separator>
        {{$t('organization.details.edit.names')}}
      </section-separator>
      <small>{{$t('organization.details.edit.names.saveTip')}}</small>
      <hr class="mt-1 mb-4">

      <organization-names v-model="organisation_names">

      </organization-names>

      <section-separator>
        {{$t('organization.details.edit.info')}}
      </section-separator>
      <small>{{$t('organization.details.edit.saveTip')}}</small>
      <hr class="mt-1 mb-4">

      <organization-infos v-model="organisation_info"/>
    </template>
  </base-form>
</template>
<script>
  import Vue from 'vue'
  import ImageUpload from 'src/components/ImageUpload'
  import Wysiwyg from 'src/components/Wysiwyg/RedactorWysiwyg'
  import VueGoogleAutocomplete from 'src/components/Autocomplete/VueGoogleAutocomplete'
  import OrganizationNames from './OrganizationNames'
  import OrganizationInfos from './DataInfos'
  import { Select, Option } from 'element-ui'

  Vue.component(VueGoogleAutocomplete.name, VueGoogleAutocomplete)
  export default {
    name: 'organization-form',
    props: {
      loading: Boolean,
      organization: {
        type: Object,
        default: () => ({})
      }
    },
    components: {
      ImageUpload,
      Wysiwyg,
      OrganizationNames,
      OrganizationInfos,
      [Select.name]: Select,
      [Option.name]: Option
    },
    data () {
      return {
        model: {
          name: '',
          slogan: '',
          company_size: '1-10',
          company_type: 'company',
          location_hq: '',
          text_about: '',
          segment_ids: [],
          logo: null,
          header: null,
          active: true,
        },
        loadingOrganizationNames: false,
        organisation_names: [],
        organisation_info: [],
        selectedSegments: {}
      }
    },
    computed: {
      formTitle() {
        return this.organization.id ? this.$t('organization.details.edit.title') + this.organization.name : this.$t('organization.details.create.title')
      },
      modelValidations () {
        return {
          name: {
            required: true
          },
          text_about: {
            required: true
          },
        }
      },
      organisationNamesColumns () {
        return [
          {
            prop: 'name',
            label: this.$t('organizationNames.labels.name'),
            minWidth: '140px',
            sortable: true
          },
        ]
      },
      getSegmentGroupBySlug(){
        return this.$store.getters['config/getSegmentGroupBySlug']
      },
      organisationSegmentGroups() {
        return this.$store.state.config.segmentGroups.filter(sg => sg.organisations)
      },
      allSegments() {
        return this.$store.state.config.segments
      }
    },
    watch: {
      organization(newVal) {
        this.model = newVal
        if (newVal.active === undefined || newVal.active === null) {
          this.model.active = true
        }
        if (!newVal.company_type) {
          this.model.company_type = 'company'
        }
        if (newVal.organisation_names) {
          this.organisation_names = newVal.organisation_names
        }
        if (newVal.organisation_info) {
          this.organisation_info = newVal.organisation_info
        }
        this.mapSegmentsToGroups(newVal.organisation_segments)

      }
    },
    methods: {
      mapSegmentsToGroups(segments) {
        segments.forEach(segment => {
          let segmentGroup = this.organisationSegmentGroups.find(g => g.id === segment.segment_group_id)
          if (segmentGroup) {
            if (this.selectedSegments[segmentGroup.slug]) {
              this.selectedSegments[segmentGroup.slug].push(segment.id)
            } else {
              this.$set(this.selectedSegments, segmentGroup.slug, [segment.id])
            }
          }
        })
      },
      getSegmentIds() {
        let segmentIds = []
        for(let key in this.selectedSegments) {
          segmentIds.push(...this.selectedSegments[key])
        }
        return segmentIds
      },
      onImageChange (src) {
        this.model.logo = src
      },
      onHeaderChange(src) {
        this.model.header = src
      },
      onLocationChange(location) {
        this.model.location_hq = location
      },
      async onSubmit() {
        let valid = await this.$validator.validateAll()
        if (!valid) {
          return
        }
        this.model.segment_ids = this.getSegmentIds()
        this.$emit('submit', {
          model: this.model
        })
      }
    }
  }
</script>
<style>
</style>
